import * as types from "./types"


export const clearLabelDesgrabador = () => {
  return { type: types.CLEAR_LABEL_DESGRABADOR };
};

export const loadingAction = () => {
  return { type: types.LOADING };
};

export const finishedLoadingAction = () => {
  return { type: types.FINISHED_LOADING };
};

export const fetchCardsSuccessAction = (cards) => {
  console.log("cards", cards);
  
  return { type: types.FETCH_CARDS_SUCCESS, payload: { cards } };
};

export const showErrorModal = () => {
  return { type: types.SHOW_ERROR_MODAL };
};

export const showErrorModalClose = () => {
  return { type: types.SHOW_ERROR_MODAL_CLOSE };
};

export const fetchFailureAction = () => {
  return { type: types.FETCH_FAILURE };
};

 export const fetchFilterSuccessAction = (filter) => {
  return { type: types.FETCH_FILTER_SUCCESS, payload: { filter } };
};

export const fetchToken = (token) => {
  return { type: types.FETCH_TOKEN, payload: { token } };
};

export const fetchUserLogin = (status) => {
  return { type: types.LOGIN, payload: { status } };
};

export const fetchResetLogin = () => {
  return { type: types.RESET_STORE };
};


export const fetchResetNameCreate = () => {
  return { type: types.RESET_MONITOREO_CREATE_NAME_ERROR };
};


export const fetchResetDesgrabador = () => {
  return { type: types.RESET_DESGRABADOR };
};

export const fetchUrl = (url) => {
  return { type: types.URL, payload: { url } };
};

export const fetchDesgrabador = (data) => {
  return { type: types.FETCH_DESGRABADOR, payload: { data } };
};

export const setLabelDesgrabador = (data) => {
  return { type: types.SET_LABEL_DESGRABADOR, payload: { data } };
};

export const setLabelDesgrabadorHistorial = (data) => {
  return { type: types.SET_LABEL_DESGRABADOR_HISTORIAL, payload: { data } };
};

export const fetchTextos = (data) => {
  return { type: types.FETCH_TEXTOS, payload: { data } };
};

export const fetchDays = (data) => {
  return { type: types.FETCH_DAYS, payload: { data } };
};

export const fetchQuery = (data) => {
  return { type: types.FETCH_QUERY, payload: { data } };
};

export const fetchQueryName = (data) => {
  return { type: types.FETCH_QUERY_NAME, payload: { data } };
};

export const fetchQueryTitle = (data) => {
  return { type: types.FETCH_QUERY_TITLE, payload: { data } };
};

export const fetchPage = (data) => {
  return { type: types.FETCH_PAGE, payload: { data } };
};

export const fetchMedia = (data) => {
  return { type: types.FETCH_MEDIA, payload: { data } };
};

export const fetchOrder = (data) => {
  return { type: types.FETCH_ORDER, payload: { data } };
};

export const fetchCategory = (data) => {
  return { type: types.FETCH_CATEGORY, payload: { data } };
};

export const fetchCardStatus = (value) => {
  return { type: types.FETCH_CARD_STATUS, payload: { value } };
};

export const fetchFilterFlag = () => {
  return { type: types.FILTER_FLAG };
};

export const fetchFilterError = () => {
  return { type: types.FILTER_FLAG_ERROR };
};

export const fetchMonitoreoError = () => {
  return { type: types.FILTER_FLAG_MONITOREO };
};

export const fetchFilterFlagSuccess = () => {
  return { type: types.FILTER_FLAG_SUCCESS };
};

export const fetchTrello = () => {
  return { type: types.FETCH_TRELLO };
};

export const fetchTrelloSuccessAction = (id) => {
  return { type: types.FETCH_TRELLO_SUCCESS, payload: { id } };
};

export const fetchTrelloError = () => {
  return { type: types.FETCH_TRELLO_ERROR };
};

export const setLabelTrello = (id) => {
  return { type: types.SET_LABEL_TRELLO, payload: { id } };
};

export const fetchItems = (items) => {
  return { type: types.FETCH_ITEMS_MENU, payload: { items } };
};

export const fetchMessagesAppministradorSuccessAction = (data) => {
  return { type: types.FETCH_MESSAGES_APPMINISTRADOR_SUCCESS, payload: { data } };
};

export const fetchMessagesFilter = (items) => {
  return { type: types.FILTER_SIMILAR, payload: { items } };
};

export const fetchMonitoreoRequestAction = () => {
  return { type: types.FETCH_MONITOREO_REQUEST };
};

export const fetchMonitoreoSuccessAction = (items) => {
  return { type: types.FETCH_MONITOREO_SUCCESS, payload: { items } };
};

export const fetchTrelloMonitoreoRequestAction = () => {
  return { type: types.FETCH_TRELLO_MONITOREO_REQUEST };
};

export const fetchTrelloMonitoreoSuccessAction = () => {
  return { type: types.FETCH_TRELLO_MONITOREO_SUCCESS };
};

export const fetchUser = (data) => {
  return { type: types.FETCH_USER, payload: { data } };
};

export const fetchFilterAppSuccessAction = (filter) => {
  return { type: types.FETCH_FILTER_APP_SUCCESS, payload: { filter } };
};

export const fetchNewPass = (pass) => {
  return { type: types.FETCH_NEW_PASS, payload: { pass } };
};

export const fetchNewDataUser = (data) => {
  return { type: types.FETCH_NEW_USER_DATA, payload: { data } };
};

export const fetchListData = (data) => {
  return { type: types.FETCH_LIST, payload: { data } };
};

export const fetchListInvitation = (data) => {
  return { type: types.FETCH_INVITATION, payload: { data } };
};

export const fetchMediosUserQsch = (data) => {
  return { type: types.FETCH_MEDIOS_USER_QSCH, payload: { data } };
};

export const fetchCodeNewUser = (data) => {
  return { type: types.FETCH_CODE_NEW_USER, payload: { data } };
};

export const fetchFirstPass = (data) => {
  return { type: types.FETCH_FIRST_PASS, payload: { data } };
};

export const fetchFirstPassFailure = () => {
  return { type: types.FETCH_FIRST_PASS_FAILURE };
};

export const fetchCodeNewUserFail = () => {
  return { type: types.FETCH_CODE_NEW_USER_FAIL };
};

export const errorNewPassword = (status) => {
  return { type: types.ERROR_NEW_PASSWORD, payload: { status } };
};

export const errorNewData = (status) => {
  return { type: types.ERROR_NEW_DATA, payload: { status } };
};

export const errorInvitation = (status) => {
  return { type: types.ERROR_INVITATION, payload: { status } };
};

export const errorFile = (status) => {
  return { type: types.ERROR_FILE, payload: { status } };
};

export const fetchListInvitationDelete = (data) => {
  return { type: types.FETCH_DELETE_INVITATION, payload: { data } };
};

export const fetchListPedidoDelete = (data) => {
  return { type: types.FETCH_DELETE_PEDIDO, payload: { data } };
};

export const fetchLFileSuccess = () => {
  return { type: types.FETCH_FILE_SUCCESS };
};

export const fetchRedesSuccessAction = (redes) => {
  return { type: types.FETCH_REDES_SUCCESS, payload: { redes } };
};

export const fetchMonitoreoUserSuccessAction = (cards) => {
  return { type: types.FETCH_MONITOREO_USER_SUCCESS, payload: { cards } };
};

export const fetchMonitoreoUserAppError = (items) => {
  return { type: types.FETCH_MONITOREO_USER_APP_ERROR, payload: { items } };
};

export const fetchMenuUsuariosSuccessAction = (items) => {
  return { type: types.FETCH_MENU_USUARIOS_SUCCESS, payload: { items } };
};

export const fetchHomePedidosSuccessAction = (cards) => {
  return { type: types.FETCH_PEDIDOS_SUCCESS, payload: { cards } };
};

export const fetchMessagesAppministradorPedidosSuccessAction = (cards) => {
  return {
    type: types.FETCH_MESSAGES_APPMINISTRADOR_PEDIDOS_SUCCESS,
    payload: { cards },
  };
};

export const postResponseSuccessAction = (item) => {
  return { type: types.POST_RESPONSE_SUCCESS, payload: { item } };
};

export const postResponseErrorAction = (item) => {
  return { type: types.POST_RESPONSE_FAILURE, payload: { item } };
};

export const fetchSimilaresSuccessAction = (cards) => {
  return { type: types.FETCH_SIMILARES_SUCCESS, payload: { cards } };
};


export const fetchVeredictosSuccessAction = (veredictos) => {
  return { type: types.FETCH_VEREDICTOS_SUCCESS, payload: { veredictos } };
};

export const fetchMenuAppSuccessAction = (menu) => {
  return { type: types.FETCH_MENU_APP_SUCCESS, payload: { menu } };
};

export const fetchGraficoSuccessAction = (grafico) => {
  return { type: types.FETCH_GRAFICO_SUCCESS, payload: { grafico } };
};

// NUEVO MONITOREO actions
export const fetchMonitoreoSuccessTrendingsAction = (items) => {
  return { type: types.FETCH_MONITOREO_SUCCESS_TRENDINGS, payload: { items } };
};

export const fetchCategoriasDetalleSuccess = (categorias_detalle) => {
  return {
    type: types.FETCH_CATEGORIAS_DETALLE_SUCCESS,
    payload: { categorias_detalle },
  };
};

export const fetchMonitoreoIDSuccessAction = (items) => {
  return { type: types.FETCH_MONITOREO_SUCCESS_ID, payload: { items } };
};

export const fetchMonitoreoSuccessCategorias = (items) => {
  return {
    type: types.FETCH_MONITOREO_SUCCESS_CATEGORIAS_FORM,
    payload: { items },
  };
};

export const fetchCardsMonitoreoSuccessAction = (items) => {
  return { type: types.FETCH_MONITOREO_SUCCESS_CARDS, payload: { items } };
};

export const fetchDetalleDesinformacionesSuccess = (items) => {
  return {
    type: types.FETCH_MONITOREO_SUCCESS_DESINFORMACIONES_DETALLE,
    payload: { items },
  };
};

export const fetchSearchMonitoreoRequestAction = () => {
  return { type: types.FETCH_MONITOREO_REQUEST_SEARCH };
};

export const postMonitoreoAsociadoStatusSuccess = (data) => {
  return { type: types.POST_MONITOREO_ASOCIADO_SUCCESS, payload: { data } };
};

export const postMonitoreoAsociadoStatusFailure = () => {
  return { type: types.FETCH_MONITOREO_ASOCIADO_FAILURE };
};

export const makeresetRegistroStatus = () => {
  return { type: types.RESET_REGISTRO_STATUS };
};


export const showStatusRegistroManualError = () => {
  return { type: types.RESET_REGISTRO_STATUS_MANUAL_ERROR };
};

export const fetchMonitoreoSuccessDesinformacionesID = (items) => {
  return {
    type: types.FETCH_MONITOREO_SUCCESS_DESINFORMACIONES_ID,
    payload: { items },
  };
};

export const makeresetRegistroStatusManual = () => {
  return { type: types.RESET_REGISTRO_STATUS_MANUAL };
};

export const updateMonitoreoCardsAction = (cards, index) => {
  return {
    type: types.UPDATE_MONITOREO_CARDS,
    payload: { cards, index },
  };
};

export const fetchGuardadosPageSuccessAction = (items) => {
  return { type: types.FETCH_REGISTRADOS_PAGE_SUCCESS, payload: { items } };
};

export const fetchMonitoreoNuevoIdSuccessAction = (id) => {
  return { type: types.FETCH_MONITOREO_SUCCESS_NUEVO_ID, payload: id };
};

export const fectchRegistroID = (id) => {
  return { type: types.FETCH_REGISTRO_ID_SUCCESS, payload: { id } };
};

export const fetchDesgrabadorErrorClean = () => {
  return { type: types.FETCH_DESGRABADOR_ERROR_CLEAN };
};


export const fetchGuardadosIDdataSuccessAction = (items) => {
  return { type: types.FETCH_REGISTRO_ID_DATA_SUCCESS, payload: { items } };
};

export const changeExpand = () => {
  return { type: types.CHANGE_VIEW };
};

export const fetchDataSuccessAction = (status) => {
  return { type: types.FETCH_DATA_SUCCESS, payload: { status } };
};

export const fetchDataSuccessCampanas = (items) => {
  return { type: types.FETCH_DATA_CAMPANAS_SUCCESS, payload: { items } };
};


export const getCleanErrorDesgrabador = () => {
  return { type: types.FETCH_DESGRABADOR_ERROR_CLEAN };
};


export const monitoreoToggleForm = (openForm, form_id, publication_id) => {
  return {
    type: types.MONITOREO__TOGGLE_FORM,
    payload: { openForm, form_id, publication_id },
  };
};


export const chequeadorToggleForm = (openForm, form_id, publication_id) => {
  return {
    type: types.CHEQUEADOR__TOGGLE_FORM,
    payload: { openForm, form_id, publication_id },
  };
};

export const monitoreoSetLoadPublicationCardSelectedID = (cardSelectId) => {
  return {
    type: types.MONITOREO__SET_LOAD_PUBLICATION_CARD_SELECTED_ID,
    payload: { cardSelectId },
  };
};

export const monitoreoCreateNewCardAction = (newCard) => {
  return { type: types.MONITOREO__NEW_CARD_CREATED, payload: { newCard } };
};

export const getCardsRequestDefault = (cards) => {
  console.log("ENTRANDO");
  
  return { type: types.FETCH_CARDS_SUCCESS, payload: { cards } };
};

export const monitoreoCardSelected = (items) => {
  return { type: types.MONITOREO__FETCH_CARD_SELECTED, payload: { items } };
};

export const monitoreoFetchAllEvents = (items) => {
  return { type: types.MONITOREO__FETCH_ALL_EVENTS, payload: { items } };
};

export const monitoreoFetchAllTopics = (items) => {
  return { type: types.MONITOREO__FETCH_ALL_TOPICS, payload: { items } };
};

export const monitoreoNewEventAction = (newEvent) => {
  return { type: types.MONITOREO__NEW_EVENT, payload: { newEvent } };
};

export const fetchDesgrabadorHistorial = (items) => {
  return { type: types.FETCH_HITORIAL_DESGRABADOR, payload: { items } };
};

export const fetchDesgrabadorHistorialID = (items) => {
  return { type: types.FETCH_HITORIAL_DESGRABADOR_ID, payload: { items } };
};

export const fetchDesgrabadorHistorialFichero = (items) => {
  return { type: types.FETCH_HITORIAL_DESGRABADOR_FICHERO, payload: { items } };
};

export const fetchDesgrabadorHistorialFicheroID = (items) => {
  return { type: types.FETCH_HITORIAL_DESGRABADOR_FICHERO_ID, payload: { items } };
};

export const fetchDesgrabadorError = () => {
  return { type: types.FETCH_DESGRABADOR_ERROR };
};


export const fetchDesgrabadorFicheroError = () => {
  return { type: types.FETCH_DESGRABADOR_FICHERO_ERROR };
};




export const fetchVerificacionesSuccessAction = (data) => {
  return { type: types.FETCH_VERIFICACIONES, payload: { data } };
};


export const fetchVerificaionesDelete = (data) => {
  return { type: types.FETCH_VERIFICACIONES_DELETE, payload: { data } };
};

export const fetchVerficacionesID = (items) => {
  return { type: types.FETCH_VERIFICACIONES_ID, payload: { items } };
};

export const fetchVerficacionesNew = (items) => {
  return { type: types.FETCH_VERIFICACIONES_NEW, payload:  {items}  };
};


export const resetChequeadorVerificacionesNew = () => ({
  type: types.RESET_CHEQUEADOR_VERIFICACIONES_NEW,
});


export const fetchVerficacionesRatingData = (items) => {
  return { type: types.FETCH_VERIFICACIONES_RATING, payload: { items } };
};

export const updateVerificacion = (items) => {
   return { type: types.UPDATE_VERIFICACION, payload: { items } };
}

export const updateVerificacionInStore = (updatedData) => {
  return { type: types.UPDATE_VERIFICACION_IN_STORE, payload: updatedData,
  };
};


export const verificacionesIsEdit = () => {
  return { type: types.VERIFICACIONES__IS__EDIT };
};

export const fetchBorrador = (items) => {
  return { type: types.VERIFICACIONES__BORRADOR, payload: { items } };
};

export const fetchBorradorDataEditar = (items) => {
  return { type: types.VERIFICACIONES__BORRADOR__DATA__EDITAR, payload: { items } };
};

export const fetchBorradorDataNuevo = (items) => {
  return { type: types.VERIFICACIONES__BORRADOR__DATA__NUEVO, payload: { items } };
};

export const setIsUploadingChequeador = (value) => {
  return { type: types.SET_UPLOADING_FILE, payload:  {value} };
};




